var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpenMindIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.387 62.366",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".open_mind_icon_svg__a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-47.634 -67.234)",
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "open_mind_icon_svg__a",
    d: "M78.22 128.6v-4.008a2.209 2.209 0 012.212-2.2 30.636 30.636 0 005.1-.565c2.1-.79 2.439-1.694 2.552-3.613a32.486 32.486 0 00-.284-5.816l4.2-1.92a1.76 1.76 0 00.737-2.54s-4.537-5.645-4.82-8.017a19.279 19.279 0 00-2.1-8.863H50.772a18.954 18.954 0 00-2.1 7.791 19.318 19.318 0 003.8 12.7c3.573 4.8 5.217 8.242 5.217 17.049M58.475 73.624a19.514 19.514 0 00-8.525 17.219l30.147-17.388a19.35 19.35 0 00-21.622.169z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "open_mind_icon_svg__a",
    cx: 0.452,
    cy: 0.452,
    r: 0.452,
    transform: "translate(77.882 78.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "open_mind_icon_svg__a",
    d: "M84.97 82.544l-4.234 1.016 1.016-4.234M81.301 82.6c5.307-3.049 5.928-10.275 3.782-14M72.246 85.764l2.42.566-.567 2.42-2.42-.567zM87.458 82.135l2.42.566-.567 2.42-2.42-.567z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "open_mind_icon_svg__a",
    d: "M64.545 87.877l-2.258-.903M62.964 88.555l.903-2.258"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpenMindIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/open_mind_icon.5e4f11cdc0bc42632c888bfc71d50499.svg";